import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Block';
import list from './list';
import create from './create';

const visitBlockedDays: ResourceProps = {
  name: 'visit-blocked-days',
  icon,
  options: { label: 'Bloqueio de agenda' },
  list,
  create
};

export default visitBlockedDays;
